import { z } from 'zod';

import { WorkoutPlanId } from '../BrandedIds';
import { BaseLoanIdSideEffect } from './BaseLoanIdSideEffect';

export const GeneratePaymentDeferralCancellationNoticeSideEffectContext = BaseLoanIdSideEffect.extend({
  workoutPlanId: WorkoutPlanId,
});

export const GeneratePaymentDeferralCancellationNoticeSideEffect =
  GeneratePaymentDeferralCancellationNoticeSideEffectContext.extend({
    type: z.literal('generatePaymentDeferralCancellationNotice'),
  });
export type GeneratePaymentDeferralCancellationNoticeSideEffect = z.infer<
  typeof GeneratePaymentDeferralCancellationNoticeSideEffect
>;
